import { render, staticRenderFns } from "./ProjectViewOverview.vue?vue&type=template&id=375c0db1&"
import script from "./ProjectViewOverview.vue?vue&type=script&lang=js&"
export * from "./ProjectViewOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewOverview.vue?vue&type=style&index=0&id=375c0db1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VRow,VSpacer})
